import React from 'react';
import styles from './worksCarousel.module.css';

import w1 from '../../images/romi_works_1.webp';
import w2 from '../../images/romi_works_2.webp';
import w3 from '../../images/romi_works_3.webp';
import w4 from '../../images/romi_works_4.webp';
import w5 from '../../images/romi_works_5.webp';
import w6 from '../../images/romi_works_6.webp';
import w7 from '../../images/romi_works_7.webp';
import w8 from '../../images/romi_works_8.webp';

const worksImages = [w1, w2, w3, w4, w5, w6, w7, w8];

const WorksCarousel = () => {
  const images = worksImages;

  return (
    <>
      <div className={styles.explain}>
      </div>

      <div className={styles.worksContainer}>
        <div className={styles.worksScrollTrack}>
          {/* Set 1 */}
          <div className={styles.worksScrollContainer}>
            {images.map((img, index) => (
              <div key={`set1-${index}`} className={styles.worksImageWrapper}>
                <img
                  src={img}
                  alt={`עבודה ${index + 1}`}
                  className={`${styles.worksImage} ${index === 2 ? styles.zoomIn : ''}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Set 2 - duplicate for seamless loop */}
          <div className={styles.worksScrollContainer}>
            {images.map((img, index) => (
              <div key={`set2-${index}`} className={styles.worksImageWrapper}>
                <img
                  src={img}
                  alt={`עבודה ${index + 1}`}
                  className={`${styles.worksImage} ${index === 2 ? styles.zoomIn : ''}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WorksCarousel;

